import React, { Component } from "react";

import {
  Wrapper,
  Title,
  Row,
  Button,
  Icon,
  Split
} from "app/NativeComponents/common";

class ListItem extends Component {
  isChecked() {
    for (let i = 0; i < this.props.selected_tags.length; i++) {
      if (this.props.selected_tags[i].id === this.props.item.id) {
        return true;
      }
    }

    return false;
  }

  renderTagActionButton() {
    if (parseInt(this.props.item.custom_tag) === 1) {
      return (
        <Button
          style={{
            width: 50,
            alignItems: "center",
            justifyContent: "center"
          }}
          onPress={() => {
            this.props.setModal({
              title: "Remove Custom Tag?",
              description: "Are you sure you want to remove this custom tag?",
              icon: "error",
              submit: "Remove Tag",
              onPress: () => {
                this.props.removeTeamTag({
                  token: this.props.token,
                  tag_id: this.props.item.id,
                  type: "remove"
                });
                this.props.getTags(this.props.token);
              },
              cancel: "Nevermind",
              onCancel: () => {}
            });
            this.props.toggleModal({ show: true, type: "normal" });
          }}
        >
          <Icon
            color={this.props.colors.light_text_color}
            icon={"close"}
            size={26}
          />
        </Button>
      );
    } else {
      return (
        <Button
          style={{
            width: 50,
            alignItems: "center",
            justifyContent: "center"
          }}
          onPress={() => {
            this.props.setModal({
              title: "Hide Default Tag?",
              description: "Are you sure you want to hide this default tag?",
              icon: "visibility-off",
              submit: "Hide Tag",
              onPress: () => {
                this.props.hideDefaultTag({
                  token: this.props.token,
                  tag_id: this.props.item.id,
                  type: "hide"
                });
                this.props.getTags(this.props.token);
              },
              cancel: "Not right now.",
              onCancel: () => {}
            });
            this.props.toggleModal({ show: true, type: "normal" });
          }}
        >
          <Icon
            color={this.props.colors.light_text_color}
            icon={"visibility"}
            size={26}
          />
        </Button>
      );
    }
  }

  render() {
    return (
      <Wrapper
        style={{
          borderBottomWidth: 1,
          borderBottomColor: this.props.colors.border_color,
          borderBottomStyle: "solid",
          padding: 15
        }}
      >
        <Split>
          <Button
            onPress={() => {
              this.props.checkItem(this.props.item);
            }}
          >
            <Row>
              <Wrapper
                style={{
                  padding: 15,
                  alignItems: "flex-start",
                  justifyContent: "center",
                  alignSelf: "stretch"
                }}
              >
                <Icon
                  icon={
                    this.isChecked() ? "check-box" : "check-box-outline-blank"
                  }
                  size={22}
                />
              </Wrapper>
              <Title>{this.props.item.title}</Title>
            </Row>
          </Button>
          {this.renderTagActionButton()}
        </Split>
      </Wrapper>
    );
  }
}

export default ListItem;
